import { IInitialState } from 'store/models';
import { respondentDataSelector } from './respondentDataSelector';

export function isSurveyQuickSelector(state: IInitialState) {
	return respondentDataSelector(state)?.quick;
}
